var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main-inner',{attrs:{"title":"调拨单"}},[_c('layout-card-wrap',[_c('allocate-table-all')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }